module.exports = __webpack_public_path__ + "img/videoBut.d8d1fed5.png";